import api from './rest';

export default api;
